import { ElementType } from '../../../../common/elements/elementTypes';
import { TABLE_CELL_EDITOR_KEY, TABLE_GRID_EDITOR_KEY } from '../../../../common/table/tableConstants';

/**
 * Returns the editor id used for the table title/session editor.
 */
export const getTableEditorId = (elementId: string): string => `${elementId}-${ElementType.TABLE_TYPE}`;

/**
 * Returns the editor id used for the single-cell editor.
 */
export const getTableCellEditorId = (elementId: string): string => `${elementId}-${TABLE_CELL_EDITOR_KEY}`;

/**
 * Returns the editor id used for the grid-level editor session.
 */
export const getTableGridEditorId = (elementId: string): string => `${elementId}-${TABLE_GRID_EDITOR_KEY}`;

/**
 * Returns whether the given editor key corresponds to a table edit mode
 */
export const isTableEditorKey = (editorKey: string | undefined): boolean =>
    editorKey === TABLE_GRID_EDITOR_KEY || editorKey === TABLE_CELL_EDITOR_KEY;
